import { h, render, Component } from 'preact';


const  facebookIcon = (props) => (
	<svg id="facebook" version="1.1" xmlns="http://www.w3.org/2000/svg" xlinkHref="http://www.w3.org/1999/xlink" viewBox="0 0 72 72" class={props.class}>
		<path d="M26.6,15.7v9.7h-7.1v11.9h7.1V70h14.7V37.3h9.8c0,0,0.9-5.7,1.4-12H41.4v-8.1c0-1.2,1.6-2.8,3.2-2.8h8V2H41.7C26.3,2,26.6,13.9,26.6,15.7z" />
	</svg>
);

export default facebookIcon;


// WEBPACK FOOTER //
// ../q-components/components/icons/socialIcons/facebook/index.js